import React from "react";
import Sidebar from "./Components/Sidebar/Sidebar";

const Layout = ({ children }) => {
  return (
    <div className="flex h-screen overflow-hidden">
      <div className="">
        <Sidebar />
      </div>

      <main className="flex-grow p-4 overflow-y-auto">{children}</main>
    </div>
  );
};

export default Layout;
